import { actions } from 'react/api/actions/configuration';
import { checkPermissions } from 'react/utils/utils';

/* eslint-disable no-param-reassign */
function sortMenusByUrl(menu) {
  const rg = /((#\/)?([\w/]{1,})\??)/;
  return menu.reduce((acc, curr) => {
    if (curr?.url?.match(rg)) {
      const url = curr.url.match(rg);
      const pathname = url[3];
      acc[pathname] = {
        iframeUrl: curr.iframeUrl
      };
    }
    if (curr.submenus) {
      acc = {
        ...acc,
        ...sortMenusByUrl(curr.submenus)
      };
    }
    return acc;
  }, {});
}

function removePanelsFromMenu(menu, configuration) {
  const panelsLength = configuration.panels.length;
  const subMenusLength = menu.submenus.length;
  const indexToStartTheDeletion = subMenusLength - panelsLength;

  menu.submenus.splice(indexToStartTheDeletion);
}

function addPanelsToMenu(menu, configuration) {
  const dispatchingLiveSubmenusLength = menu.submenus.length;

  configuration.panels.forEach(({ id, name }, panelsIterator) => {
    const panelItem = {
      id,
      name,
      url: `#/Panel/${id}`,
      panel: 'panel',
      isFirstPanel: panelsIterator === 0
    };

    const subMenuItemIndex = dispatchingLiveSubmenusLength + panelsIterator + 1;

    menu.submenus.splice(subMenuItemIndex, 0, panelItem);
  });
}

function updateDispatchingMenus(menu, configuration) {
  for (
    let subMenusIterator = 0;
    subMenusIterator < menu.submenus.length;
    subMenusIterator++
  ) {
    if (menu.submenus[subMenusIterator].name === 'topMenu.report') {
      const storedReports = configuration.featureStates.get('STORED_REPORTS');

      if (storedReports?.enabled && storedReports?.parameters?.url) {
        menu.submenus.splice(subMenusIterator + 1, 0, {
          name: 'topMenu.analytics.myReports',
          url: storedReports.parameters.url,
          panel: 'panel',
          external: true
        });
      }
    }
  }

  configuration.panels
    && addPanelsToMenu(menu, configuration);
}

function updateSystemSettingsMenu(menu) {
  const menuAlreadyExists = menu.submenus.findIndex(
    ({ name }) => name === 'topMenu.security.samlConfiguration'
  );
  if (menuAlreadyExists !== -1) return;

  const hasSamlPermission = checkPermissions('SAMLCONFIGURATION_LIST')
  || checkPermissions('SAMLCONFIGURATION_CREATE')
  || checkPermissions('SAMLCONFIGURATION_EDIT')
  || checkPermissions('SAMLCONFIGURATION_DELETE');

  if (hasSamlPermission) {
    const securityPolicyIndex = menu.submenus.findIndex(
      ({ name }) => name === 'topMenu.securityPolicy'
    );
    const hasSecurityPolicyPermission = securityPolicyIndex !== -1;
    const samlMenuIndex = securityPolicyIndex + 1 || menu.submenus.length - 1;
    const securityPolicyMenuId = hasSecurityPolicyPermission
      ? menu.submenus[securityPolicyIndex].id
      : 0;
    const samlMenuId = securityPolicyMenuId + 1;

    const samlMenu = {
      id: samlMenuId,
      name: 'topMenu.security.samlConfiguration',
      url: '#/SamlConfiguration'
    };
  
    if (Monet.Session.Security.screens.indexOf('/SamlConfiguration') === -1) {
      Monet.Session.Security.screens.push('/SamlConfiguration');
    }
  
    menu.submenus.splice(samlMenuIndex, 0, samlMenu);
  }
}

function getConfigurationWithMenusUpdated(configuration) {
  configuration.menus.forEach((menu) => {
    if (menu.name === 'topMenu.dispatchingLive') {
      updateDispatchingMenus(menu, configuration);
    } else if (
      menu.name === 'topMenu.systemSettings') {
      updateSystemSettingsMenu(menu);
    }
  });

  configuration.menusOrderedByUrl = sortMenusByUrl(configuration.menus);

  return configuration;
}

export default (state = { loggedUser: {}, mdlpStatus: false }, action) => {
  const { type, payload } = action;

  if (type === actions.setConfiguration) {
    const { configuration } = payload;

    return getConfigurationWithMenusUpdated(configuration);
  }

  if (type === actions.updateMenuPanelBuilder) {
    const { configuration } = payload;

    const menus = state?.menus

    menus.forEach((menu) => {
      if (menu.name === 'topMenu.dispatchingLive') {
        removePanelsFromMenu(menu, configuration);
        addPanelsToMenu(menu, configuration);
      }
    });

    return { ...state, menus };
  }

  if (type === actions.updateMdlpStatus) {
    const { mdlpStatus } = payload;

    return Object.assign(state, { mdlpStatus });
  }

  return state;
};
